<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
  },
  watch: {
    '$route.path': (newVal, oldVal) => {
      console.log(newVal)
    },
  },
}
</script>

<style lang="less">
@import './assets/css/base_css.less';
html,
body,
#app {
  width: 100%;
  height: 100%;
  background: #ffffff;
  color: #333333;
}
p {
  margin: 0;
}

ul,
li {
  list-style: none;
  padding: 0;
}
/* 修复固定列边框问题 */
.ant-table-fixed-right {
  // border-left: 1px solid #e8e8e8;
  // border-right: 1px solid #e8e8e8;
}

.ant-table-fixed-right table {
  // border-left: 1px solid #e8e8e8;
  // border-right: 1px solid #e8e8e8;
}

.ant-table-fixed-right .ant-table-thead > tr > th {
  // border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
}

.ant-table-fixed-right .ant-table-tbody > tr > td {
  // border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

/* 确保固定列与主体高度一致 */
.ant-table-fixed-right,
.ant-table-fixed-left {
  height: 100%;
}

.ant-table-fixed-right .ant-table-tbody,
.ant-table-fixed-left .ant-table-tbody {
  height: 100%;
}
</style>
